export default __webpack_public_path__ + "static/media/user_expanded.d8adaf83.jpg";